import { createFileRoute, Link } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery } from "@tanstack/react-query";
import { getMyCoachCompanies } from "@/lib/coach-portal.functions";
import { Building2, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/coach-portal/")({
  component: CoachPortalIndex,
});

function CoachPortalIndex() {
  const fetchCompanies = useServerFn(getMyCoachCompanies);
  const { data, isLoading, error } = useQuery({
    queryKey: ["coach-portal", "companies"],
    queryFn: () => fetchCompanies(),
  });

  if (isLoading) return <div className="p-8 text-sm text-muted-foreground">Laddar…</div>;
  if (error) return <div className="p-8 text-sm text-destructive">{(error as Error).message}</div>;

  const companies = data?.companies ?? [];

  return (
    <div className="px-6 md:px-10 py-10 max-w-5xl">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.22em] text-muted-foreground mb-2">Coach-portal</div>
        <h1 className="font-display text-3xl">Mina bolag</h1>
        <p className="text-sm text-muted-foreground mt-2">
          Här ser du de bolag du är tilldelad som coach. Klicka för att uppdatera milstolpar, TRL-nivåer och anteckningar.
        </p>
      </div>

      {companies.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-12 text-center text-sm text-muted-foreground">
          <Building2 className="size-8 mx-auto mb-3 opacity-50" />
          Du är inte tilldelad något bolag ännu. Kontakta Inkubera.
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {companies.map((c) => (
            <Link
              key={c.id}
              to="/coach-portal/$companyId"
              params={{ companyId: c.id }}
              className="group rounded-2xl border border-border bg-card p-5 hover:border-foreground/30 transition-colors"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="font-display text-lg">{c.name}</div>
                  <div className="text-xs text-muted-foreground mt-1">
                    {c.fas} · {c.status}
                    {c.municipality ? ` · ${c.municipality}` : ""}
                  </div>
                  {c.is_primary && (
                    <span className="inline-block mt-2 text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full bg-secondary">
                      Huvudcoach
                    </span>
                  )}
                </div>
                <ArrowRight className="size-4 text-muted-foreground group-hover:text-foreground transition-colors" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
